import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SOLUTIONS = [
  "Professional Website",
  "Local SEO",
  "Quote Capture",
  "Google Presence",
  "Facebook Business Setup",
  "Customer Enquiry System",
];

export default function CaseStudyTeaser() {
  return (
    <section id="case-study" data-testid="case-study-section" className="py-20 sm:py-28">
      <div className="section-shell grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <Reveal className="lg:col-span-6">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden border border-sky-500/20 vignette" style={{ clipPath: "polygon(0 0, 100% 0, 100% calc(100% - 48px), calc(100% - 48px) 100%, 0 100%)" }}>
              <img
                src="https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxtZWNoYW5pYyUyMHdvcmtzaG9wJTIwY2FyJTIwcmVwYWlyfGVufDB8fHx8MTc5MDc5NzU3Mnww&ixlib=rb-4.1.0&q=85"
                alt="Auto electrician carrying out diagnostic repair work in a workshop"
                className="w-full h-72 sm:h-96 object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute bottom-5 left-5 glass-panel rounded-full px-4 py-2 flex items-center gap-2">
              <MapPin size={13} className="text-sky-400" />
              <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-slate-200">Greater London</span>
            </div>
          </div>
        </Reveal>
        <div className="lg:col-span-6">
          <Reveal>
            <p className="micro-label">Featured Case Study</p>
            <h2 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-white">
              One Time Auto Electrical Repairs
            </h2>
            <p className="mt-3 font-mono text-xs uppercase tracking-[0.18em] text-sky-400">
              Mobile auto electrician · Serving Greater London
            </p>
            <p className="mt-5 text-sm sm:text-base leading-relaxed text-slate-400 max-w-xl">
              Our first full build: a complete digital presence for a mobile auto electrical specialist,
              combining a professional website, local search visibility and a quote capture system designed
              to make it easier for customers across Greater London to find the business and send enquiries.
            </p>
          </Reveal>
          <Reveal delay={0.12}>
            <ul className="mt-7 flex flex-wrap gap-2.5" data-testid="case-study-solutions">
              {SOLUTIONS.map((s) => (
                <li key={s} className="rounded-full border border-sky-500/25 bg-sky-500/5 px-4 py-1.5 text-xs font-semibold text-sky-300">
                  {s}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.2}>
            <Link to="/case-study/one-time-auto-electrical" data-testid="btn-view-case-study" className="btn-primary mt-9">
              View Case Study <ArrowRight size={16} strokeWidth={2.5} />
            </Link>
            <p className="mt-4 text-xs text-slate-500">A real project breakdown — no inflated numbers, just the work.</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
